// src/demo/demoAccess.js
//
// Statyczna konfiguracja DEMO (marketingowa).
// NIE mieszać z lessonAccess.js (to jest od "wkrótce dostępne" / placeholderów).

import { getSoonNoteForGuest } from "../lessonAccess";

export const DEMO_PREFIX = "/demo";
export const DEMO_TOPIC_PREFIX = "/demo-temat";
export const DEMO_TOPIC_ACTIVE_SUBTOPIC_KEY = "mt_demo_topic_active_subtopic_id";
export const DEMO_TOPIC_SOURCE_SEO_SLUG_KEY = "mt_demo_topic_source_seo_slug";

// Główne DEMO pokazuje tylko jeden dział (II. Algebra)
export const DEMO_SECTION_INDEX = 1; // 0-based: II. Algebra
export const DEMO_ALLOWED_SECTION_INDICES = new Set([DEMO_SECTION_INDEX]);

// DEMO SEO może otwierać temat z dowolnego działu, ale tylko ten,
// który został ustawiony jako aktywny po wejściu ze strony SEO.
export const DEMO_TOPIC_ALLOWED_SECTION_INDICES = new Set(
  Array.from({ length: 20 }, (_, index) => index)
);

// Odblokowane w głównym DEMO (/demo): wyselekcjonowany temat pokazowy + quiz tematu
export const DEMO_ALLOWED_TOPIC_IDS = new Set(["2_3"]);

export const DEMO_ALLOWED_SUBTOPIC_IDS = new Set([
  "2_3_1",
  "2_3_2",
  "2_3_3",
]);

export const DEMO_TOPIC_ALLOWED_SUBTOPIC_IDS = new Set([
  "1_1_2",
  "1_1_3",
  "1_1_4",
  "1_2_1",
  "1_3_3",
  "1_4_1",
  "1_4_4",
  "1_5_2",
  "1_5_3",
  "2_1_2",
  "2_2_1",
  "2_2_2",
  "2_3_1",
  "2_3_2",
  "3_2_1",
  "3_3_1",
  "4_2_1",
  "4_3_1",
  "5_1_1",
  "6_1_8",
  "6_1_9",
  "6_1_2",
  "6_1_4",
  "7_1_1",
  "7_1_2",
  "7_1_3",
  "7_2_1",
  "7_3_1",
]);

export const DEMO_ALLOW_TOPIC_QUIZ_IDS = new Set(["2_3"]);
export const DEMO_TOPIC_ALLOW_TOPIC_QUIZ_IDS = new Set([]);

function getStorage() {
  if (typeof window === "undefined") return null;
  try {
    return window.sessionStorage;
  } catch (_) {
    return null;
  }
}

export function setDemoTopicActiveSubtopicId(subtopicId) {
  const storage = getStorage();
  if (!storage) return;
  const id = String(subtopicId || "").trim();
  if (!id) return;
  storage.setItem(DEMO_TOPIC_ACTIVE_SUBTOPIC_KEY, id);
}

export function setDemoTopicSourceSeoSlug(slug) {
  const storage = getStorage();
  if (!storage) return;
  if (slug == null) return;
  const safeSlug = String(slug || "").trim();
  if (!safeSlug) return;
  storage.setItem(DEMO_TOPIC_SOURCE_SEO_SLUG_KEY, safeSlug);
}

export function getDemoTopicActiveSubtopicId() {
  const storage = getStorage();
  if (!storage) return "";
  return String(storage.getItem(DEMO_TOPIC_ACTIVE_SUBTOPIC_KEY) || "");
}

export function getDemoTopicSourceSeoSlug() {
  const storage = getStorage();
  if (!storage) return "";
  return String(storage.getItem(DEMO_TOPIC_SOURCE_SEO_SLUG_KEY) || "");
}

export function isDemoPath(pathname = "") {
  return (
    pathname.startsWith(`${DEMO_PREFIX}/`) ||
    pathname.startsWith(`${DEMO_TOPIC_PREFIX}/`)
  );
}

export function isDemoTopicPath(pathname = "") {
  return pathname.startsWith(`${DEMO_TOPIC_PREFIX}/`);
}
export function demoBase(pathname = "") {
  if (pathname.startsWith(`${DEMO_TOPIC_PREFIX}/`)) return DEMO_TOPIC_PREFIX;
  if (pathname.startsWith(`${DEMO_PREFIX}/`)) return DEMO_PREFIX;
  return "";
}

export function isDemoAllowedTopic(topicId) {
  return DEMO_ALLOWED_TOPIC_IDS.has(String(topicId || ""));
}

export function isDemoAllowedSubtopic(subtopicId, pathname = "") {
  const id = String(subtopicId || "");
  if (pathname.startsWith(`${DEMO_TOPIC_PREFIX}/`)) {
    const active = getDemoTopicActiveSubtopicId();
    if (!active) return false;
    return id === active;
  }
  return DEMO_ALLOWED_SUBTOPIC_IDS.has(id);
}

export function getDemoAllowedTopicQuizIds(pathname = "") {
  if (pathname.startsWith(`${DEMO_TOPIC_PREFIX}/`)) {
    return DEMO_TOPIC_ALLOW_TOPIC_QUIZ_IDS;
  }
  return DEMO_ALLOW_TOPIC_QUIZ_IDS;
}

export function getDemoAllowedSectionIndices(pathname = "") {
  if (pathname.startsWith(`${DEMO_TOPIC_PREFIX}/`)) {
    return DEMO_TOPIC_ALLOWED_SECTION_INDICES;
  }
  return DEMO_ALLOWED_SECTION_INDICES;
}

// Spójny "note" dla kafelków/list w DEMO dla gościa:
// - standardowo: "Dostępne po rejestracji"
// - jeśli w lessonAccess jest placeholder: "Po rejestracji (wkrótce)"
export function getDemoLockedNoteForGuest(lessonId) {
  return getSoonNoteForGuest(lessonId);
}
